import classNames from 'classnames';
import { Tooltip } from 'antd';
import type { TooltipProps } from 'antd';
import type { themeColourAttributes } from '@app/utils/constants';

export type StyleTooltipProps = TooltipProps & {
    color?: keyof typeof themeColourAttributes;
    size?: 'small' | 'middle' | 'large';
    /**
     * Display the arrow?
     */
    showArrow?: boolean;
};

/**
 * Primary UI component for user interaction
 */
export const StyledTooltip = ({
    color,
    size = 'middle',
    showArrow = true,
    ...props
}: StyleTooltipProps) => {
    const tooltipRootClasses = classNames(
        'styled-tooltip',
        {
            [`styled-tooltip-color-${color}`]: color,
            [`styled-tooltip-${size}`]: size,
            'is-arrow-hidden': !showArrow,
        },
        props.classNames
    );

    return (
        <Tooltip
            {...props}
            classNames={{ ...props.classNames, root: tooltipRootClasses }}
            data-testid="styled-tooltip">
            {props.children}
        </Tooltip>
    );
};
